import styled, { keyframes } from 'styled-components';
import { ReactComponent as FeatherImg } from 'products/global/assets/img/join-us/feather-white.svg';
import { motion } from 'framer-motion';
import { sizes } from 'style';

const carousel = (offset) =>
  keyframes`
    from {
      transform : translateX(0px)
    }
    to {
      transform : translateX(${-offset}px)
    }
`;

export const FlipLetter = styled.span`
  display: inline-block;
  transform: rotateZ(180deg) translateY(-10px);
`;

export const Crossed = styled.span`
  position: relative;
  display: inline-block;

  > img {
    position: absolute;
    left: -9px;
    top: 22px;
  }
`;

export const CardsContainer = styled.div`
  display: none;
  cursor: default;
  width: fit-content;
  animation: ${({ offset }) => carousel(offset)} 80s infinite linear normal;
  padding-top: 25px;
  padding-bottom: 40px;

  @media ${sizes.desktop} {
    display: flex;
  }
`;

export const Card = styled.div`
  height: 260px;
  perspective: 1000px;
  pointer-events: auto;
  width: ${({ cardWidth }) => `${cardWidth}px`};
  margin-right: ${({ marginRight }) => `${marginRight}px`};
`;

export const Wrapper = styled.div`
  max-width: ${({ maxWidth }) => `${maxWidth}px`};
  margin: 0px auto;
  position: relative;
  display: flex;
  width: 100%;
  overflow: hidden;
  pointer-events: none;

  :hover > ${CardsContainer} {
    animation-play-state: paused;

    > ${Card} {
      animation-play-state: paused;
    }
  }
`;

export const Flip = styled(motion.div)`
  transform-style: preserve-3d;
  border-radius: 20px;
  width: 100%;
  height: 100%;
  position: relative;
  box-shadow: 0px 8px 32px rgba(15, 23, 42, 0.16);
`;

export const Feather = styled(FeatherImg)`
  height: 56px;
  width: 29px;
  align-self: flex-end;
  position: absolute;
`;

export const Name = styled.h2`
  margin: 0;
  margin-top: auto;
  font-size: 44px;
  line-height: 49px;
`;

export const Front = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  padding: 18px 15px 22px 20px;
  border-radius: 20px;
  background-color: ${({ frontBg }) => frontBg};
  flex-direction: column;
  justify-content: space-between;
  backface-visibility: hidden;
  transform: rotateY(0deg);
`;

export const Back = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 20px;
  top: 0;
  left: 0;
  background-color: ${({ backBg }) => backBg};
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transform: rotateY(180deg);
  padding: 21px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > h3 {
    font-size: 16px;
    margin: 0px;
  }

  > span {
    font-family: Nimbus;
    font-style: italic;
  }
`;

export const Description = styled.p`
  font-size: 22px;
  line-height: 30px;
  letter-spacing: -1px;
  margin: 0;
`;
